





























import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import { DateTime } from "luxon";

// See https://github.com/kaorun343/vue-property-decorator for all options

interface PresetDate {
    label: string;
    value: string;
    start: DateTime;
    end: DateTime;
}

@Component({
    name: "DatePicker",
})
export default class DatePicker extends Vue {
    DateTime = DateTime;

    @Prop()
    maxWidth: string;

    @Prop({ required: true })
    date: DateTime; // the one being passed in
    internalDate: DateTime | null = null; // the one we use internally
    vuetifyDate: string = "";

    menuOpen: boolean = false;

    created() {
        this.internalDate = this.date;
        this.vuetifyDate = this.internalDate.toISODate();
    }
    @Watch("vuetifyDate", { deep: true })
    updateDates() {
        this.internalDate = DateTime.fromISO(this.vuetifyDate);
        this.$emit("update:date", this.internalDate);
        this.$emit("change", this.internalDate);
    }

    // Somehow doesn't update when using as computed (getter)
    get inputDisplayValue(): string {
        return this.internalDate.toLocaleString(DateTime.DATE_MED);
    }
}
